import type { TourDef, TourId, TourStep } from "./types";

/** Welcome only shows to people who joined on/after this. Set to the Hub release date. */
export const WELCOME_TOUR_SINCE = "2026-10-20T00:00:00Z";

const step = (tour: TourId, target: string, name: string, extra: Partial<TourStep> = {}): TourStep => ({
  target,
  titleKey: `${tour}.${name}Title`,
  bodyKey: `${tour}.${name}Body`,
  placement: "right",
  ...extra,
});

const intro = (tour: TourId) => ({ titleKey: `${tour}.introTitle`, bodyKey: `${tour}.introBody` });

export const TOURS: Record<TourId, TourDef> = {
  welcome: {
    id: "welcome",
    intro: intro("welcome"),
    steps: [
      step("welcome", "nav.upload", "upload"),
      step("welcome", "sessions.list", "list", { placement: "bottom", route: "/sessions" }),
      step("welcome", "nav.account-tile", "switch"),
    ],
    outroKey: "welcome.outro",
  },
  session: {
    id: "session",
    intro: intro("session"),
    steps: [
      step("session", "session.footage", "footage"),
      step("session", "session.tools.plays", "plays", { placement: "left" }),
      step("session", "session.tools.roster", "roster", { placement: "left" }),
      step("session", "session.header.share", "share", { placement: "bottom" }),
    ],
    outroKey: "session.outro",
  },
  team: {
    id: "team",
    intro: intro("team"),
    steps: [
      step("team", "nav.account-tile", "crest"),
      step("team", "nav.upload", "upload"),
      step("team", "settings.members", "members", { route: "/sessions?settings=members" }),
      step("team", "settings.roster", "roster", { route: "/sessions?settings=roster" }),
    ],
    outroKey: "team.outro",
  },
  developer: {
    id: "developer",
    intro: intro("developer"),
    // Each tab step switches to that tab and spotlights it in the sidebar.
    steps: [
      step("developer", "developer.quickstart", "quickstart", { placement: "bottom", route: "/developer" }),
      step("developer", "developer.mcp", "mcp", { placement: "top", route: "/developer" }),
      step("developer", "nav.organization/api-keys", "keys", { route: "/organization/api-keys" }),
      step("developer", "nav.organization/webhooks", "webhooks", { route: "/organization/webhooks" }),
      step("developer", "nav.developer/usage", "usage", { route: "/developer/usage" }),
      step("developer", "nav.developer/logs", "logs", { route: "/developer/logs" }),
    ],
    outroKey: "developer.outro",
  },
};
